import { PassMdl, TravelProposalMdl } from './../../../Models/TravelProposalMdl';
import { LanguageService } from './../../../Services/languageService';
import { restURL } from './../../../Models/restURL';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { TravelPolicyModel } from './../../../Models/TravelPolicyModel';
import { TravelBindMdl } from './../../../Models/TravelBindMdl';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Component, ViewChild, ElementRef } from '@angular/core';
import { RegModel } from '../../../Models/RegModel';
import { userService } from '../../../Services/userService';
import { motorProposalService } from '../../../Services/motorProposalService';
import swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { MotorStatusMdl } from '../../../Models/MotorStatusMdl';
import { environment } from '../../../environments/environment';
declare let $: any;

@Component({
  selector: 'TravelBasicInfo',
  templateUrl: './TravelBasicInfo.html',
  styleUrls: ['./TravelBasicInfo.css']
})
export class TravelBasicInfo {
  public httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
  public travelBindObj: TravelBindMdl = new TravelBindMdl();
  public prObj: TravelProposalMdl = new TravelProposalMdl();
  public travelPolicyObj: TravelPolicyModel = new TravelPolicyModel();
  public isShowLoading: boolean = false;
  public LngSubscription: Subscription;
  public Lng: string;
  public isSubmitted: boolean;
  public HasIBANNo: boolean;
  public IBANNo: string;
  public travelRegObj: RegModel = new RegModel();
  public agreeTerms: boolean;
  public ShowHigherPositionFeild: boolean = false;
  public agreeKYC: boolean;
  public CityName: string;
  public agreeNatAdd: boolean;

  public passObj = new PassMdl();
  public headers = new HttpHeaders();
  public AttachementError: string = "";
  public IsIDCopyUploaded:boolean = false;
  public IsPassportCopyUploaded:boolean = false;

  @ViewChild('txtIBAN2') txtIBAN2Element: ElementRef;
  @ViewChild('txtIBAN3') txtIBAN3Element: ElementRef;
  @ViewChild('txtIBAN4') txtIBAN4Element: ElementRef;
  @ViewChild('txtIBAN5') txtIBAN5Element: ElementRef;
  @ViewChild('txtIBAN6') txtIBAN6Element: ElementRef;
  constructor(private translate: TranslateService,private EncriptService: motorProposalService,private router: Router, private http: HttpClient, public url: restURL, private lngService: LanguageService, private userinfo: userService) {

    this.isSubmitted = false;
    this.agreeTerms = false;
    // this.prObj.IOccupation="";
    this.LngSubscription = this.lngService.grtLng().subscribe(lng => { this.Lng = lng });
    if (sessionStorage.getItem("Language") != null) {
      this.Lng = sessionStorage.getItem("Language");
    }
    else {
      this.Lng = "en";
    }



    this.getBindInfo();


  }
  getBindInfo() {

    if (sessionStorage.getItem("TravelBindObj") != null) {
      //this.travelBindObj = JSON.parse(sessionStorage.getItem("TravelBindObj"));
      this.travelBindObj = JSON.parse(this.EncriptService.DecriptObject(sessionStorage.getItem("TravelBindObj")));


    
      this.prObj = this.travelBindObj.propoalObj;

      this.prObj.PrefCommLng = "E"
      this.prObj.PrefCommType = "SMS"
     
      if(sessionStorage.getItem("IsTravelEdit") == "N"){
        this.prObj.IsVaccinated = null;
        this.prObj.IsHigherPosition = null;
      }
  


    }
    else {
      sessionStorage.setItem("CurrentRoute", "TravelPolicy");
      this.router.navigate(['NewDashboard/TravelPolicy']);
    }
    if(this.prObj.ICity!="" && this.prObj.ICity!=null){
      this.CityName = this.travelBindObj.cityList.filter(t => t.CityCode == Number(this.prObj.ICity))[0].CityNameEn;
    }
    // alert("From Date="+this.prObj.TravelFrom+"  ToDate="+this.prObj.TravelTo);

  }


  ngAfterViewInit() {

    $(document).ready(function () {

      $('[data-toggle="popover"]').popover({
        placement: 'top',
        trigger: 'hover'
      });
    });
  }
  iban1Changed(event) {

    if (event != "" && event != undefined && event != null) {
   
      if (event.length == 2) {
     
        setTimeout(() => this.txtIBAN2Element.nativeElement.focus(), 0);
      }
    }
  }

  iban2Changed(event) {
    if (event != "" && event != undefined && event != null) {

      if (event.length == 4) {
        let bankCode: string = event.substring(0, 2)
        this.prObj.BankCode = bankCode;
        if (this.travelBindObj.bankList.filter(t => t.BankCode == bankCode).length > 0) {
          setTimeout(() => this.txtIBAN3Element.nativeElement.focus(), 0);
        }
        else {
          setTimeout(() => this.txtIBAN2Element.nativeElement.focus(), 0);
        }


      }
    }
  }


  iban3Changed(event) {
    if (event != "" && event != undefined && event != null) {
      //alert(event.length);
      if (event.length == 4) {
        setTimeout(() => this.txtIBAN4Element.nativeElement.focus(), 0);
      }
    }
  }

  iban4Changed(event) {
    if (event != "" && event != undefined && event != null) {
      //alert(event.length);
      if (event.length == 4) {
        setTimeout(() => this.txtIBAN5Element.nativeElement.focus(), 0);
      }
    }
  }

  iban5Changed(event) {
    if (event != "" && event != undefined && event != null) {
      //alert(event.length);
      if (event.length == 4) {
        setTimeout(() => this.txtIBAN6Element.nativeElement.focus(), 0);
      }
    }
  }


  setBankCode(IBAN) {
    let bankCode: string = IBAN.substring(0, 2)
    this.prObj.BankCode = bankCode;
    if (IBAN != "" && IBAN != undefined && IBAN != null) {
      //alert(event.length);
      if (IBAN.length == 4) {
        let bankCode: string = IBAN.substring(0, 2)
        this.prObj.BankCode = bankCode;
        if (this.travelBindObj.bankList.filter(t => t.BankCode == bankCode).length > 0) {
          //  alert("test");
          setTimeout(() => this.txtIBAN3Element.nativeElement.focus(), 0);
        }
        else {
          setTimeout(() => this.txtIBAN2Element.nativeElement.focus(), 0);
          this.Lng == "en" ? swal("Invalid IBAN Number") : swal("رقم الايبان غير صحيح");
        }


      }
    }


    //alert(bankCode);
  }

  GoNext(valid) {
  
    this.isSubmitted = true;
    if(this.IsIDCopyUploaded == false){
      swal(this.translate.instant("Please Upload ID Copy"));
      return;
    }
    if(this.IsPassportCopyUploaded == false){
      swal(this.translate.instant("Please Upload Passport Copy"));
      return;
    }

    if(!this.agreeKYC){
      swal(this.translate.instant("Please check KYC Details"));
      return;
    }
    if(!this.agreeNatAdd){
      swal(this.translate.instant("Please agree National Address Declaration"));
      return;
    }
    if (valid) {
      this.prObj.HigherPositionCode = Number(this.prObj.HigherPositionCode);
      this.prObj.IBAN = "SA" + this.prObj.IBAN1 + this.prObj.IBAN2 + this.prObj.IBAN3 + this.prObj.IBAN4 + this.prObj.IBAN5 + this.prObj.IBAN6;
      if (this.prObj.IBAN1 == null || this.prObj.IBAN2 == null || this.prObj.IBAN3 == null || this.prObj.IBAN4 == null || this.prObj.IBAN5 == null || this.prObj.IBAN6 == null || this.prObj.IBAN.length != 24) {
        this.Lng == "en" ? alert("IBAN Number must be 24 digits") : alert("يجب أن يكون رقم الايبان من 24 رقماً");
      }
      else {

        this.isShowLoading == true;

        this.travelBindObj.propoalObj = this.prObj;
        //sessionStorage.setItem("TravelBindObj", JSON.stringify(this.travelBindObj));
        sessionStorage.setItem("TravelBindObj", this.EncriptService.EncriptObject(JSON.stringify(this.travelBindObj)));

        sessionStorage.setItem("CurrentRoute", "TravelReviewConfirm");
        this.router.navigate(['NewDashboard/TravelProposalForm/TravelReviewConfirm']);
        this.isShowLoading == false;
        //alert("From  Date="+this.travelBindObj.propoalObj.TravelFrom+" To  Date="+this.travelBindObj.propoalObj.TravelTo);

      }

    }

  }



  IsHigherPosition(val) {

    if (val == "true") {
      this.prObj.IsHigherPosition = true;
      this.ShowHigherPositionFeild = true;
    } else {
      this.prObj.IsHigherPosition = false;
      this.prObj.HigherPositionCode = 0;
      this.ShowHigherPositionFeild = false;

    }
  }
  IsVaccinated(val){
    if(val == "true"){
      this.prObj.IsVaccinated = true;
    }else{
      this.prObj.IsVaccinated = false;
    }
  }

  ValidateSpecialCharacters(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || (k>1500 && k<1650) || k == 8 || k == 32);
  }

  OnSelectIDCopy(event, passObj) {

    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]);
      var fsize = event.target.files[0].size / 1048576;
      var fileName = event.target.files[0].name;
      var fileExt = fileName.substring(fileName.lastIndexOf(".") + 1);
      this.passObj.IDCopyName = this.travelBindObj.propoalObj.RegNo.toString() + "_" + this.travelBindObj.propoalObj.Insured_IDNo + "_IdCopy." + fileExt;
      if (fileExt.toString().toUpperCase() != "JPG" && fileExt.toString().toUpperCase() != "JPEG" && fileExt.toString().toUpperCase() != "PNG") {
        swal("Please select valid image");
        return;
      }

      var isvalid = "";
      if (fsize > 2) {
        swal("File Size Should not exceed 2 MB");
        return;
      }
      var fd = new FormData();
      fd.append("file", event.target.files[0]);
      fd.append("fileType", "IdCopy");
      fd.append("attchmentId", this.travelBindObj.propoalObj.RegNo.toString() + "_" + this.travelBindObj.propoalObj.Insured_IDNo)

      this.uploadFile(fd, this.passObj.IDCopyName,"IDCOPY");
      reader.onload = (event) => {
        if (fsize < 2) {
          let target = <any>event.target;
          let image = target.result;
          this.passObj.IDCopy = image.split(",")[1];
        }


      }
    }
  }
  OnSelectPassportCopy(event, passObj) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]);
      var fsize = event.target.files[0].size / 1048576;
      var fileName = event.target.files[0].name;
      var fileExt = fileName.substring(fileName.lastIndexOf(".") + 1);
      this.passObj.PassportCopyName = this.travelBindObj.propoalObj.RegNo.toString() + "_" + this.travelBindObj.propoalObj.Insured_IDNo + "_PassportCopy." + fileExt;
      if (fileExt.toString().toUpperCase() != "JPG" && fileExt.toString().toUpperCase() != "JPEG" && fileExt.toString().toUpperCase() != "PNG") {
        swal("Please select valid image");
        return;
      }

      var isvalid = "";
      if (fsize > 2) {
        swal("File Size Should not exceed 2 MB");
        return;
      }
      var fd = new FormData();
      fd.append("file", event.target.files[0]);
      fd.append("fileType", "PassportCopy");
      fd.append("attchmentId", this.travelBindObj.propoalObj.RegNo.toString() + "_" + this.travelBindObj.propoalObj.Insured_IDNo)

      this.uploadFile(fd, this.passObj.PassportCopyName,"PASSPORTCOPY");
      reader.onload = (event) => {
        if (fsize < 2) {
          let target = <any>event.target;
          let image = target.result;
          this.passObj.PassportCopy = image.split(",")[1];
        }


      }
    }
  }

  uploadFile(fd, CopyName,filetype) {
    var param = environment;              
    if (!param.St.StatusDesc) {
        throw new Error("Encryption key is not initialized.");
    }

    var UserName = this.EncriptService.EncriptPayload(JSON.stringify(param.Master.Code));
    var Password = this.EncriptService.EncriptPayload(JSON.stringify(param.Master.Description));
    
    this.isShowLoading = true;

    this.headers = new HttpHeaders();
    this.headers.delete('Content-Type');
    this.headers.set('enctype', "multipart/form-data");
    this.headers = this.headers.append('Accept-Encoding', 'gzip');
    this.headers = this.headers.append('apiToken', this.getToken());
    this.headers = this.headers.append("Authorization", "Basic " + btoa(UserName + ':' + Password));

    this.http.post<MotorStatusMdl>(this.url.baseURL + "/Proposal/SaveAttachments", fd, { headers: this.headers }).toPromise().then(
      (res) => {
        this.isShowLoading = false;
        if (res.StatusCode == "F") {
          swal(res.StatusDesc);
          this.AttachementError = this.AttachementError + CopyName;
          return;
        }
        else {
          this.AttachementError = this.AttachementError.replace(CopyName, "");
        }
        
        if(filetype == "IDCOPY"){
          swal("ID COPY Uploaded","","success")
          this.IsIDCopyUploaded = true;
          this.prObj.InsuredIDCopy = this.passObj.IDCopyName;
        }
        if(filetype == "PASSPORTCOPY"){
          swal("PASSPORT COPY Uploaded","","success")
          this.IsPassportCopyUploaded = true;
          this.prObj.PassportIDCopy = this.passObj.PassportCopyName;
        }
      }, (error) => {
        this.isShowLoading = false;
        swal("Upload Fail","Could Not Upload File. Internal Server Error","error")
      });

  }
  getToken(): string {
    let token: string = "";
    if (sessionStorage.getItem("token") != null) {
      token = sessionStorage.getItem("token");
    }
    return token;
  }

  


}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/TravelPortal/TravelBasicInfo/TravelBasicInfo.ts